import H1 from "../../components/element/H1";
import Button from "../../components/element/Button";
import React from "react";
import EntityApi from "../../api/EntityApi";
import {Link, useNavigate, useParams, useLocation} from "react-router-dom";
import {PartitionOutlined} from '@ant-design/icons';

import {
    CodeDocIcon,
    HtmlDocIcon,
    ImageDocIcon,
    PdfDocIcon,
    SlideshowDocIcon,
    TextDocIcon,
    VideoDocIcon,
    ExamIcon, UnknownDocIcon
} from "../../assets/icons";
import {ListItemProps} from "../../components/catalog/ListItem";
import ListChapter from "../../components/catalog/ListChapter";
import ModalAjax from "../../components/main/ModalAjax";
import ModalMaterialAjax from "../../components/main/ModalMaterialAjax";
import useAuth from "../../hooks/useAuth";
import {ArrowRightOutlined} from "@ant-design/icons";
import { Modal, Button as ButtonAntd } from 'antd';
import ExamTesting from "../testing/user/ExamTesting";
import IconMaterial from "../../components/element/IconMaterial";

const CourseDetailPage = () => {

    const {id} = useParams();
    const { roles } = useAuth();
    const [ title, setTitle ] = React.useState('');
    const [ code, setCode ] = React.useState('');
    const [ chapters, setChapters ] = React.useState([]);
    const [ chapterActive, setChapterActive ] = React.useState(0);
    const [ chapterTitle, setChapterTitle ] = React.useState('');
    const [ chapterText, setChapterText ] = React.useState('');
    const [ chapterNext, setChapterNext ] = React.useState(0);
    const [ chapterNextTitle, setChapterNextTitle ] = React.useState('');
    const [ isOpenMaterial, setIsOpenMaterial ] = React.useState(false);
    const [ materialActive, setMaterialActive ] = React.useState(0);
    const [ materials, setMaterials ] = React.useState([]);
    const [ counters, setCounters ] = React.useState({});
    const [ isLoading, setLoading ] = React.useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;
    const [testingMaterial, setTestingMaterial] = React.useState(0);
    const [testingStart, setTestingStart] = React.useState(false);
    const [isOpenTesting, setOpenTesting] = React.useState(false);
    const [materialExam, setMaterialExam] = React.useState(0);

    const [isOpenMobileCats, setIsOpenMobileCats] = React.useState(false);

    React.useEffect(() => {

        if (id != undefined && parseInt(id) > 0) {

            EntityApi.get('private/product', parseInt(id)).then((data) => {
                setTitle(data.content.item.title);
                setCode(data.content.item.code);
                setMaterialExam(data.content.item.material_exam);

                if (data.content.item.chapters) {
                    setChapters(data.content.item.chapters);
                    data.content.item.chapters.forEach((item, index) => {
                        if (index === 0) {
                            //setChapterActive(item.id); // Активируем первую главу
                            if (item.chapters) {
                                item.chapters.forEach((subItem, subIndex) => {
                                    if (subIndex === 0) {
                                        setChapterActive(subItem.id); // Активируем первую подглаву
                                        setChapterTitle(subItem.title);
                                    }
                                })
                            }
                            //setChapterActive(item.id);
                            //setChapterTitle(item.title);
                        }
                    });
                }

                if (data.content.item.counters) {
                   /* data.content.item.counters.forEach((counter, type) => {

                    })*/
                    setCounters(data.content.item.counters);
                }

                setLoading(false);

            });

        }

    }, [])

    React.useEffect(() => {

        if (chapterActive <= 0) return;

        setMaterials([]);

        EntityApi.get('private/chapter', chapterActive).then((data) => {
            setChapterText(data.content.item.description);
        });

        EntityApi.getBy('private/material', {
            filter: { chapter: chapterActive, product: id}
        }).then((data) => {
            if (data.content.items) {
                setMaterials(data.content.items);
            }
        });

        // проверить есть нет еще главы другие
        let isFindCurrent = false;
        let next = 0;
        let nextTitle = '';
        chapters.forEach((chap) => {
            // Если надо будет включить главы
            /*if (isFindCurrent) {
                setChapterNext(chap.id);
                isFindCurrent = false;
            }*/
            if (chap.id === chapterActive) {
                isFindCurrent = true;
            }
            chap.chapters.forEach((subchap) => {
                if (isFindCurrent) {
                    next = subchap.id;
                    nextTitle = subchap.title;
                    isFindCurrent = false;
                }
                if (subchap.id === chapterActive) {
                    isFindCurrent = true;
                }
            })
        })

        setChapterNext(next);
        setChapterNextTitle(nextTitle);

    }, [chapterActive])

    React.useEffect(() => {
        if (testingMaterial > 0) {
            setOpenTesting(true);
        } else {
            setOpenTesting(false);
        }
    }, [testingMaterial])

    React.useEffect(() => {
        if (isOpenTesting) {
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        } else {
            document.getElementsByTagName('html')[0].style.overflow = '';
        }
    }, [isOpenTesting])

    const materialLoad = (id, type) => {

        if (type === 'testing') {
            setTestingMaterial(id);
            return true;
        }

        setMaterialActive(id);
        setIsOpenMaterial(true);
    }

    const chapterSelect = (id, title) => {
        setChapterActive(id);
        setChapterTitle(title);
    }

    const chapterSelectMob = (id, title) => {
        setIsOpenMobileCats(false);
        setChapterActive(id);
        setChapterTitle(title);
    }

    const pr1 = {
        paddingLeft: ".25rem"
    }

    const onEditCourse = () => {
        navigate('/cabinet/catalog/form/course/' + id);
    }

    const openTesting = (materialId) => {

    }

    const renderIcon = (type) => {
        switch (type) {
            case 'html':
                return <HtmlDocIcon/>;
                break;
            case 'text':
                return <TextDocIcon/>;
                break;
            case 'pdf':
                return <PdfDocIcon/>;
                break;
            case 'image':
                return <ImageDocIcon/>;
                break;
            case 'video':
                return <VideoDocIcon/>;
                break;
            case 'code':
                return <CodeDocIcon/>;
                break;
            case 'slideshow':
                return <SlideshowDocIcon/>;
                break;
            case 'testing':
                return <ExamIcon/>;
                break;
            case 'file':
                return <UnknownDocIcon/>;
                break;
            default:
                <></>
        }
    }

    return <>
        <div className={"w-full pb-6 flex justify-end card-product__events"}>
            <div className={'flex justify-center space-x-2'}>
                <Button text={"Назад"} type={"default"}
                        onClick={() => navigate(locationState ? locationState.prevPath : '/cabinet/catalog')}/>
                {
                    roles.includes('ROLE_ADMIN') &&
                    <Button text={"Изменить"} type={'primary'} onClick={() => onEditCourse()}/>
                }
            </div>
        </div>
        <div className="card card-product p-4 lg:p-6">
            {
                isLoading &&
                <>
                    <div
                        className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
                        <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
                    </div>
                    <div className={"h-64"}></div>
                </>
            }
            <H1 text={title}/>
            <div className={"flex mob-block card-product__attrs pt-3 text-lg items-center"}>
                {code != '' &&
                    <div className={"pr-6 card-product__attrs-code"}><b>Код:</b> {code}</div>
                }
                <div className={"flex card-product__attrs-icons"}>
                    {
                        counters.chapters &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <PartitionOutlined style={{
                                    fontSize: "30px",
                                    transform: 'rotate(90deg)',
                                    top: '3px',
                                    position: 'relative'
                                }}/>
                            </div>
                            <div style={pr1}>{counters.chapters}</div>
                        </div>
                    }
                    {
                        counters.text &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <TextDocIcon/>
                            </div>
                            <div style={pr1}>{counters.text}</div>
                        </div>
                    }
                    {counters.html &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <HtmlDocIcon/>
                            </div>
                            <div style={pr1}>{counters.html}</div>
                        </div>
                    }
                    {counters.video &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <VideoDocIcon/>
                            </div>
                            <div style={pr1}>{counters.video}</div>
                        </div>
                    }
                    {counters.pdf &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <PdfDocIcon/>
                            </div>
                            <div style={pr1}>{counters.pdf}</div>
                        </div>
                    }
                    {counters.image &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <ImageDocIcon/>
                            </div>
                            <div style={pr1}>{counters.image}</div>
                        </div>
                    }
                    {counters.slideshow &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <SlideshowDocIcon/>
                            </div>
                            <div style={pr1}>{counters.slideshow}</div>
                        </div>
                    }
                    {counters.testing &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <ExamIcon/>
                            </div>
                            <div style={pr1}>{counters.testing}</div>
                        </div>
                    }
                    {counters.file &&
                        <div className={"flex items-center justify-center mr-4"}>
                            <div className={"w-7"}>
                                <UnknownDocIcon/>
                            </div>
                            <div style={pr1}>{counters.file}</div>
                        </div>
                    }
                </div>
                {
                    materialExam > 0 &&
                    <div style={{marginLeft: 'auto'}}>
                        <Button onClick={() => materialLoad(materialExam, 'testing')} text={'Итоговое тестирование'}
                                type={'primary'}/>
                    </div>
                }
            </div>
        </div>

        <div className={'desktop-hidden'}>
            <ButtonAntd className={'mt-4 desktop-hidden w-full'} onClick={() => setIsOpenMobileCats(!isOpenMobileCats)}>Список глав курса</ButtonAntd>
            <Modal
                style={{top: '0px'}}
                title="Список глав курса"
                open={isOpenMobileCats}
                footer={''}
                onCancel={() => setIsOpenMobileCats(false)}>
                <ul className={"space-y-1.5 font-inter font-medium"}>
                    {
                        chapters.length > 0 && chapters.map((chapter, index) =>
                            <React.Fragment key={chapter.id}>
                                <ListChapter
                                    onClick={chapter.chapters && (() => chapterSelectMob(chapter.chapters[0].id, chapter.chapters[0].title))}
                                    isSub={!!chapter.chapters} id={chapter.id} title={chapter.title}
                                    active={chapterActive === chapter.id ? 'active' : 'default'}/>
                                {/*<ListChapter onClick={() => chapterSelect(chapter.id, chapter.title)} isSub={!!chapter.chapters} id={chapter.id} title={chapter.title} active={chapterActive === chapter.id ? 'active' : 'default' }/>*/}
                                {
                                    chapter.chapters && chapter.chapters.map((subchapter, subIndex) =>
                                        <ListChapter onClick={() => chapterSelectMob(subchapter.id, subchapter.title)}
                                                     key={subchapter.id} isSub={false} id={subchapter.id}
                                                     title={subchapter.title}
                                                     active={chapterActive === subchapter.id ? 'active' : 'default'}/>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </ul>
            </Modal>
        </div>

        <div className={"flex mt-6 card-product__content"}>
            <div className={"w-4/12 mob-hidden"}>
                <div className={"card"}>
                    <div className={"p-4 sm:px-5"}>
                        <ul className={"space-y-1.5 font-inter font-medium"}>
                            {
                                chapters.length > 0 && chapters.map((chapter, index) =>
                                    <React.Fragment key={chapter.id}>
                                        <ListChapter
                                            onClick={chapter.chapters && (() => chapterSelect(chapter.chapters[0].id, chapter.chapters[0].title))}
                                            isSub={!!chapter.chapters} id={chapter.id} title={chapter.title}
                                            active={chapterActive === chapter.id ? 'active' : 'default'}/>
                                        {/*<ListChapter onClick={() => chapterSelect(chapter.id, chapter.title)} isSub={!!chapter.chapters} id={chapter.id} title={chapter.title} active={chapterActive === chapter.id ? 'active' : 'default' }/>*/}
                                        {
                                            chapter.chapters && chapter.chapters.map((subchapter, subIndex) =>
                                                <ListChapter onClick={() => chapterSelect(subchapter.id, subchapter.title)}
                                                             key={subchapter.id} isSub={false} id={subchapter.id}
                                                             title={subchapter.title}
                                                             active={chapterActive === subchapter.id ? 'active' : 'default'}/>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className={"w-8/12 ml-4"}>
                <div className={"card p-4 lg:p-6"}>
                    <H1 text={chapterTitle}></H1>
                    {chapterText != '' ?
                        <div className={"pt-4"} dangerouslySetInnerHTML={{__html: chapterText}}></div> : ''}
                    {
                        materials.map((material) => {
                            if (material.is_hide) {
                                return;
                            }
                            if (material.in_modal || material.type === 'file') {
                                if (material.type === 'file') {
                                    return <div key={material.id} className={"flex mt-3 w-full"}>
                                        <div className={"flex h-9 w-10 items-center justify-center mr-4"}>
                                            <IconMaterial type={'file'} width={'100%'}/>
                                        </div>
                                        <Link
                                            className={'btn w-full bg-slate-150 font-medium text-slate-800 hover:bg-slate-200 focus:bg-slate-200 active:bg-slate-200/80'}
                                            to={material.url} download={material.title + '.' + material.url_ext}
                                            target={'_blank'}>{material.title}</Link>
                                        {/*<Button onClick={() => window.open(material.url, '_blank')} text={material.title}/>*/}
                                    </div>
                                }
                                return <div key={material.id} className={"flex mt-3 w-full"}>
                                    <div className={"flex h-9 w-10 items-center justify-center mr-4"}>
                                        {
                                            renderIcon(material.custom_type ? material.custom_type : material.type)
                                        }
                                    </div>
                                    <Button onClick={() => materialLoad(material.id, material.type)}
                                            text={material.title}/>
                                </div>
                            } else {
                                if (material.type === 'pdf') {
                                    return <div key={material.id} className={"flex mt-3 w-full"}>
                                        <div className={"flex h-9 w-10 items-center justify-center mr-4"}>
                                            <IconMaterial type={'pdf'} width={'100%'}/>
                                        </div>
                                        <Button onClick={() => window.open(material.url, '_blank')}
                                                text={material.title}/>
                                    </div>
                                }
                                if (material.type === 'text' || material.type === 'code') {
                                    return <div className={"mt-3"}>
                                        {
                                            !material.is_hide_title &&
                                            <h2 className={"text-xl font-medium"}>{material.title}</h2>
                                        }
                                        <div className={"mt-6"}
                                             dangerouslySetInnerHTML={{__html: material.text.replace(/(?:\r\n|\r|\n)/g, '<br>')}}></div>
                                        <div className={"mt-6"}></div>
                                    </div>
                                }
                                if (material.type === 'html') {
                                    return <div className={"mt-3"}>
                                        {
                                            !material.is_hide_title &&
                                            <h2 className={"text-xl font-medium"}>{material.title}</h2>
                                        }
                                        <div className={"mt-6"} dangerouslySetInnerHTML={{__html: material.html}}></div>
                                        <div className={"mt-6"}></div>
                                    </div>
                                }
                                if (material.type === 'video') {
                                    return <div className={"w-6/12"}>
                                        <video controls>
                                            <source src={material.url} type={"video/mp4"}/>
                                        </video>
                                    </div>
                                }
                                if (material.type === 'image') {
                                    return <img src={material.url}/>
                                }
                            }
                        })
                    }
                    {chapterNext > 0 &&
                        <div className={'w-2/12 mt-8 mob-w-full'}>
                            <Button onClick={() => chapterSelect(chapterNext, chapterNextTitle)} type={'primary'}
                                    text={<span>Далее <ArrowRightOutlined/></span>}/>
                        </div>
                    }

                </div>
            </div>
        </div>
        <ModalMaterialAjax id={materialActive} isOpen={isOpenMaterial} onClose={() => setIsOpenMaterial(false)}/>
        <Modal
            footer={null}
            style={{top: '10px'}}
            width={testingStart ? '80%' : '500px'}
            open={isOpenTesting}
            maskClosable={false}
            afterClose={() => setTestingMaterial(0)}
            onCancel={() => setTestingMaterial(0)}>
            {
                <ExamTesting
                    onStart={(start) => setTestingStart(start)}
                    onClose={() => setTestingMaterial(0)}
                    materialId={testingMaterial}/>
            }
        </Modal>
    </>

}

export default CourseDetailPage;
